/** Shared archival detail sentence for the per-class AutoArchiveChip and the home AutoArchiveBanner. */
export const AUTO_ARCHIVE_DETAIL_COPY =
  'Archived classes are unavailable to students and prevent additional enrollments. You can still ' +
  'view data from archived classes, but you will not be able to create new assignments. Unarchive a ' +
  'class at any time in its settings.';
